import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, withStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { convertDateToDisplay } from "../../../helpers/convert-date-to-display";
import { IParkingLotTableProps } from "./props";
import "./parking-lot-table.scss";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ParkingLotTable(props: IParkingLotTableProps)
{
    const renderAlert = (errorMsg: string | undefined) =>
    {
        // eslint-disable-next-line no-null/no-null
        if (!errorMsg)
        {
            return (
                <Alert className="table-alert" severity="success">Helyes működés</Alert>
            );
        }
        else
        {
            return (
                <Alert className="table-alert" severity="warning">{errorMsg}</Alert>
            );
        }
    };

    return (
        <TableContainer component={Paper} className="parking-lot-table">
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Dátum</TableCell>
                        {props.allPlacesVisible ? <TableCell>Összes hely</TableCell> : undefined}
                        <TableCell>Normál szabad</TableCell>
                        <TableCell>Rokkant szabad</TableCell>
                        <TableCell>E-töltő szabad</TableCell>
                        <TableCell>Szabálytalan parkolások</TableCell>
                        <TableCell>Státusz</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.data.map((row, i) => (
                        <TableRow
                            key={i}
                        >
                            <TableCell component="th" scope="row">
                                {typeof row.date === "string" ? convertDateToDisplay(new Date(row.date))
                                    : convertDateToDisplay(row.date)}
                            </TableCell>
                            {props.allPlacesVisible
                                ? (
                                    <TableCell component="th" scope="row">
                                        {row.allPlaces}
                                    </TableCell>
                                ) : undefined
                            }

                            <TableCell>{row.cars}</TableCell>
                            <TableCell>{row.accessibles}</TableCell>
                            <TableCell>{row.chargers}</TableCell>
                            <TableCell>{row.illegal}</TableCell>
                            <TableCell>{renderAlert(row.errorMsg)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
